import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import NavBar from '../components/Menu/NavBar'
import { pageStyle } from '../components/UIComponent/CommonStyle'
import MyCalendar from '../components/MyCalendar';

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function MyCalendarPage() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar />
            <MyCalendar />
        </div>
    )
}